import { create } from 'zustand';

interface MenuDrawerState {
	isOpen: boolean;
	open: () => void;
	close: () => void;
	toggle: () => void;
}

/**
 * Global store for the mobile menu drawer that opens from the BottomNav's
 * "Menu" hamburger tab. Modeled after `useLoginModalStore` so the open
 * trigger doesn't need prop-drilling through PortalLayout.
 */
export const useMenuDrawerStore = create<MenuDrawerState>((set, get) => ({
	isOpen: false,
	open: () => set({ isOpen: true }),
	close: () => set({ isOpen: false }),
	toggle: () => set({ isOpen: !get().isOpen }),
}));
